import { PlacementErrorType } from '@frontend/sports/types/betslip';

import { stringToNullableNumber } from '../error-convert-helpers';
import { UserError } from './user-error';

export class WrongCurrency extends UserError {
    constructor(userCurrency: string | undefined, betCurrency: string | undefined) {
        super();
        this.userCurrency = stringToNullableNumber(userCurrency);
        this.betCurrency = stringToNullableNumber(betCurrency);
        this.type = PlacementErrorType.WrongCurrency;
    }

    userCurrency: number | null;
    betCurrency: number | null;
}
